import { useTranslation } from 'react-i18next'
import { Select as AntSelect, Spin } from 'antd'
import { faUsers } from '@fortawesome/pro-solid-svg-icons/faUsers'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import EmptyState from 'components/reusables/emptyState'
import Select from 'components/reusables/select'
import { ProfileBadge } from 'components/reusables/profileBadge'
import { IProfile } from 'interfaces/users'
import { Wrapper, Subtitle, OptionWrapper } from './styled'

const { Option } = AntSelect

interface IProps {
  profiles: IProfile[]
  loading: boolean
  selectedProfiles: IProfile[]
  setSelectedProfiles: (profiles: IProfile[]) => void
}

const SelectProfiles = ({
  profiles,
  loading,
  selectedProfiles,
  setSelectedProfiles,
}: IProps) => {
  const { t } = useTranslation()
  const prefix =
    'configuration.rolesAndPermissions.assignRole.inputs.chooseAccessLevel.profiles'

  return (
    <Wrapper $isEmpty={selectedProfiles.length === 0}>
      <Subtitle>{t(`${prefix}.title`)}</Subtitle>
      <Spin spinning={loading}>
        <Select
          showSearch={true}
          mode="multiple"
          value={selectedProfiles.map((profile) => profile.id)}
          placeholder={t(`${prefix}.placeholder`)}
          onSelect={(value) =>
            setSelectedProfiles([
              ...selectedProfiles,
              profiles.find((profile) => profile.id === value) as IProfile,
            ])
          }
          onDeselect={(value) =>
            setSelectedProfiles(
              selectedProfiles.filter((profile) => profile.id !== value)
            )
          }
          notFoundContent={
            <EmptyState title={t(`${prefix}.emptyState`)} icon={faUsers} />
          }
        >
          {profiles.map((item) => (
            <Option key={item.id} value={item.id} label={item.name}>
              <OptionWrapper>
                <ProfileBadge name={item.name} color={item.color} />
                <FontAwesomeIcon
                  icon={faTimes as IconProp}
                  onClick={() =>
                    setSelectedProfiles(
                      selectedProfiles.filter(
                        (profile) => profile.id !== item.id
                      )
                    )
                  }
                />
              </OptionWrapper>
            </Option>
          ))}
        </Select>
      </Spin>
    </Wrapper>
  )
}

export default SelectProfiles
